import { PageHeader } from "../components/PageHeader";
import { config } from "../lib/config";

export function Privacy() {
  return (
    <>
      <PageHeader
        eyebrow="الخصوصية"
        title="سياسة الخصوصية"
        description="توضح هذه الصفحة طبيعة البيانات التي تجمعها المنصة وكيفية استخدامها والاحتفاظ بها في المرحلة الحالية."
      />
      <section className="py-20">
        <div className="container max-w-4xl space-y-7 text-lg leading-10 text-graphite">
          <p>
            تجمع المنصة بيانات الجهة الطالبة، بيانات التواصل، بيانات العقار،
            الغرض من الطلب، الوصف المختصر، ومرفقات PDF المرتبطة بالطلب.
          </p>
          <p>
            تستخدم البيانات والمرفقات لغرض مراجعة طلب التقييم الهندسي وإدارته
            داخلياً من قبل إدارة {config.companyLegalNameAr}، ولا توفر المنصة في
            هذه المرحلة بوابة عملاء أو تتبعاً عاماً لحالة الطلب.
          </p>
          <p>
            تحفظ المرفقات في تخزين خاص بصيغة مشفرة قبل حفظها في التخزين
            الكائني، ولا يتم نشر روابط عامة لها. يمكن الوصول إليها فقط عبر نقطة
            تنزيل محمية للإدارة الداخلية تقوم بفك التشفير عند الطلب المصرح به.
          </p>
          <p>
            مدة الاحتفاظ بالمرفقات سنة ميلادية واحدة من تاريخ إغلاق الطلب، ثم
            تقوم المنصة بإتلاف مفتاح فك التشفير الخاص بالملف ومحاولة حذف الكائن
            من التخزين. وبعد إتلاف مفتاح فك التشفير لا يكون محتوى الملف قابلاً
            للقراءة عبر المنصة. تتضمن المرحلة الحالية مهمة احتفاظ داخلية لمعالجة
            الملفات التي تجاوزت تاريخ الحذف.
          </p>
        </div>
      </section>
    </>
  );
}
